import { ActionButton, createTheme, Customizations, Stack } from '@fluentui/react';
import { redirectToSelfLaunch } from 'caccl/client';
import { Outlet } from 'react-router-dom';
import { getServerHost, sendApiRequest, thisIsDevEnvironment } from '../../lib/helper';
import { useAuthenticationContext } from '../../providers/authenticationprovider';
import TopNav from '../layout/topnav';
import './app.css';

const theme = createTheme({
  // You can also modify certain other properties such as fontWeight if desired
  defaultFontStyle: { fontFamily: 'Poppins, Segoe UI, Monaco, Menlo, Consolas' }
});

Customizations.applySettings({ theme });

function App() {

  const authenticationContext = useAuthenticationContext();  
  return (
    <div className="App">
      <TopNav />          
      {!authenticationContext.Pending && !authenticationContext.Result?.IsAuthenticated && <div className='section'><Stack horizontal>
        {thisIsDevEnvironment && <div className='sign-in-section'>
        <ActionButton styles={{label: { fontSize: 18 }}} text='Sign in as a Student or Teacher' iconProps={{ iconName: "SignIn" }} onClick={() => {
          if(thisIsDevEnvironment)
          {
            redirectToSelfLaunch({courseId: 999999});
          }
          else
          {
            const apiPath = "/api/canvas/getSessionlessLaunchUrlFromCanvas";
            sendApiRequest(apiPath, "GET").catch(err => {
              console.error(err);
            });
          }
         }} />
        </div>}
        <div className='sign-in-section'>
        <ActionButton styles={{label: { fontSize: 18 }}} text='Sign in as an Accreditor or Administrator' iconProps={{ iconName: "SignIn" }} onClick={() => {
          window.location.href = `https://${getServerHost()}/login/azuread?redirect=${window.location.pathname}`;
        }} />
        </div>
      </Stack></div>}      
      {authenticationContext.Result?.IsAuthenticated &&
        <Outlet />
      }   
    </div>
  );
}

export default App;
